<template>
  <div class="">
     <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <img class="page-logo" src="@/assets/home/8.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>血型配对</span>
    </div>
    <div class="text">
      <p>
        血型配对是指根据自己的血型和恋人的血型来大致分析下双方的性格特征,并给出两人的速配指数以及性格方面的相关建议和提醒。
      </p>
    </div>

    <div class="select-time">
      <span>您的血型</span>
      <div class="select-box" @click="clickXx1">
        <span>{{ xx1 ? xx1.title : "请选择血型" }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
      <div class="sex">
        <div :class="{ action: sex1 == 1 }" @click="sex1 = 1">男</div>
        <div :class="{ action: sex1 == 0 }" @click="sex1 = 0">女</div>
      </div>
    </div>
    <div class="select-time">
      <span>您的血型</span>
      <div class="select-box" @click="clickXx2">
        <span>{{ xx2 ? xx2.title : "请选择血型" }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
      <div class="sex">
        <div :class="{ action: sex2 == 1 }" @click="sex2 = 1">男</div>
        <div :class="{ action: sex2 == 0 }" @click="sex2 = 0">女</div>
      </div>
    </div>
    <div style="height: 3rem"></div>
    <div class="start-btn" @click="start">开始测算</div>
    <select-xz @confirm="confirmXx" type="3" :data="xx" v-model="showXx" />
    <shareBottomComp v-if="share == 1"></shareBottomComp>
</div>
  </div>
</template>

<script>
/**
@description:血型配对
@createTime:2021-08-26
@create:wq
*/
import selectXz from "@/components/selectXz.vue";
import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
import topTab from "@/components/topTab";

export default {
  name: "",
  props: {},
  components: { selectXz ,shareBottomComp,topTab},
  data() {
    return {
      sex1: 1,
      sex2: 1,
      currentXx: 0,
      showXx: false,
      xx: "请选择",
      xx1: "",
      xx2: "",
      share:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'血型配对',
        path:'/xxpd'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('xxpd','血型配对','','',HERF+'/image/8.png')
  },
  methods: {
    start() {
      this.api
        .bloodGroupMatching({
          one: this.xx1.title,
          oneSex: this.sex1,
          two: this.xx2.title,
          twoSex: this.sex2,
        })
        .then((res) => {
          if (this.xx1 === "") return this.Toast("血型未选");
          if (this.xx2 === "") return this.Toast("血型未选");
          localStorage.setItem("result", JSON.stringify(res.data));
          this.$router.push("xxpdres");
        });
    },
    clickXx1() {
      this.currentXx = 0;
      this.xx = this.xx1;
      this.showXx = true;
    },
    clickXx2() {
      this.currentXx = 1;
      this.xx = this.xx2;
      this.showXx = true;
    },
    confirmXx({ date }) {
      if (this.currentXx == 0) {
        this.xx1 = date;
      } else {
        this.xx2 = date;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  /* height: 1.2rem; */
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  p {
    text-indent: 2em;
  }
}
.select-time {
  margin: 0.26rem 0;
  display: flex;
  align-items: center;
  > span {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
    margin-right: 0.38rem;
  }
  .select-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.24rem 0 0.44rem;
    border-radius: 0.5rem;
    background: #f0f0f0;
    border: 1px solid #e6e6e6;
    height: 0.76rem;
    span {
      font-size: 0.24rem;
      font-weight: 500;
      color: #cccccc;
    }
    i {
      font-size: 0.28rem;
      color: #53cedc;
    }
  }
}
.tips {
  margin-top: 0.7rem;
  display: flex;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
}

.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
.sex {
  //   padding: 0 0.34rem;
  width: 2.54rem;
  height: 0.76rem;
  border-radius: 0.4rem;
  box-sizing: border-box;
  background: #f0f0f0;
  overflow: hidden;
  margin-left: 0.36rem;
  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.4rem;
  }
  .action {
    color: #ffffff;
    background: #4fd9d5;
  }
}
</style>
